import { createAuth0 } from '@auth0/auth0-vue';

/**
 * This pattern allows to access Auth0 from outside a component
 *  @see {@link https://github.com/auth0/auth0-vue/issues/99#issuecomment-1099704276}
 */
export const auth0 = createAuth0({
  domain: "upclaim.eu.auth0.com",
  clientId: "nESYFY0qLOd7av8VtUpOT6z5AoWTy1Yw",
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: "https://upclaim.eu.auth0.com/api/v2/",
  },
});